import './App.css';
import AppController from './components/AppController';

function App() {

  return (
    <div className="App">
      <AppController/>
    </div>
  );
  
}

export default App;